import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { actions, asyncActionHandlers, initialState, reducer } from './campaignStatusReducer'

import { useReducerAsync } from 'hooks/useReducerAsync'

export const CampaignMenuContext = React.createContext()
export const CampaignMenuDispatchContext = React.createContext()

export const useCampaignMenu = () => {
  const context = React.useContext(CampaignMenuContext)
  if (context === undefined) {
    throw new Error('useCampaignMenu must be used within a CampaignMenuContextProvider')
  }
  return context
}

export const useCampaignMenuDispatch = () => {
  const context = React.useContext(CampaignMenuDispatchContext)
  if (context === undefined) {
    throw new Error('useCampaignMenuDispatch must be used within a CampaignMenuContextProvider')
  }
  return context
}

export const CampaignMenuContextProvider = ({ event, children }) => {
  const hasFetchedStatus = useRef(false)
  const [state, dispatch] = useReducerAsync(reducer, initialState(event), asyncActionHandlers)

  useEffect(() => {
    // fetch campaign status once event.id becomes available — on mobile the
    // provider mounts before the event has loaded (event.id is undefined on
    // first render), so this can't be a first-render-only check.
    if (!hasFetchedStatus.current && event.id) {
      hasFetchedStatus.current = true
      dispatch({ type: actions.fetchCampaignStatusAsync, payload: { eventId: event.id } })
    }
  }, [dispatch, event.id])

  useEffect(() => {
    if (event) {
      dispatch({ type: actions.resetMarketingCampaignStatus, payload: { event } })
    }
  }, [event, dispatch])

  return (
    <CampaignMenuContext.Provider value={state}>
      <CampaignMenuDispatchContext.Provider value={dispatch}>{children}</CampaignMenuDispatchContext.Provider>
    </CampaignMenuContext.Provider>
  )
}

CampaignMenuContextProvider.propTypes = {
  event: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}
